import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { CertPeriodsDialog } from './CertPeriodsDialog';
import { VitalsDialog } from './VitalsDialog';
import { ServiceLocationDialog } from './ServiceLocationDialog';
import { NoticeDialog } from './NoticeDialog';
import { AttachToAllDialog } from './AttachToAllDialog';
import { PreClaimDialog } from './PreClaimDialog';
import { HhvbpDialog } from './HhvbpDialog';
import { buildAdmissionProfile, patientName } from '../../utils/admissionDocs';

const ROW1 = ['Show Cert Periods', 'Print Admission Profile', 'Vitals Dashboard', 'Service Provided Location', 'HHCCN', 'NOMNC', 'Emergency Preparedness Plan', 'Attach to All'];
const ROW2 = ['Pre-Claim Review', 'HHVBP Legacy'];
const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, '-');

export const AdmissionActions = ({ patient, admission, onPatientChange }) => {
  const navigate = useNavigate();
  const [open, setOpen] = useState(null);
  const close = () => setOpen(null);
  const id = patient.id;

  const click = (name) => {
    if (name === 'Print Admission Profile') {
      buildAdmissionProfile(patient, admission).save(`Admission_Profile_${patientName(patient).replace(/\s+/g, '_')}.pdf`);
      toast.success('Admission profile downloaded');
    } else if (name === 'Emergency Preparedness Plan') {
      navigate(`/dashboard/admission/emergency-preparedness?patientId=${id}`);
    } else setOpen(name);
  };

  const btn = (name) => (
    <button key={name} onClick={() => click(name)} data-testid={`admission-action-${slug(name)}`}
      className="bg-[#5bc0de] text-white px-3 py-1.5 rounded text-sm hover:bg-[#46b8da] transition-colors">{name}</button>
  );

  return (
    <>
      <div className="flex flex-wrap gap-2 mb-4">{ROW1.map(btn)}</div>
      <div className="flex flex-wrap gap-2">{ROW2.map(btn)}</div>
      {open === 'Show Cert Periods' && <CertPeriodsDialog patientId={id} onClose={close} />}
      {open === 'Vitals Dashboard' && <VitalsDialog patientId={id} onClose={close} />}
      {open === 'Service Provided Location' && <ServiceLocationDialog patient={patient} onClose={close} onSaved={(v) => onPatientChange({ ...patient, ...v })} />}
      {open === 'HHCCN' && <NoticeDialog kind="hhccn" patient={patient} onClose={close} />}
      {open === 'NOMNC' && <NoticeDialog kind="nomnc" patient={patient} onClose={close} />}
      {open === 'Attach to All' && <AttachToAllDialog patientId={id} onClose={close} />}
      {open === 'Pre-Claim Review' && <PreClaimDialog patientId={id} onClose={close} />}
      {open === 'HHVBP Legacy' && <HhvbpDialog patientId={id} onClose={close} />}
    </>
  );
};
